import { render, staticRenderFns } from "./vps-product-classification.html.vue?vue&type=template&id=15b28ac8"
import script from "./vps-product-classification.html.vue?vue&type=script&lang=js"
export * from "./vps-product-classification.html.vue?vue&type=script&lang=js"
import style0 from "./vps-product-classification.html.vue?vue&type=style&index=0&id=15b28ac8&prod&lang=scss"
import style1 from "./vps-product-classification.html.vue?vue&type=style&index=1&id=15b28ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports